import { IState } from "@redux/store.types";
import { getValueState } from "@redux/utils";
import { $ImageViewerModuleName } from "./imageViewer.types";

const getActiveIndex = (state: IState): number => getValueState(state, $ImageViewerModuleName)?.activeIndex || 0;

export { getActiveIndex };
